<template>
  <div id="app" ref="app" class="col">
    <header-nav v-if="!isManager && !isSurveyCakePage"></header-nav>
    <div class="body">
      <router-view />
    </div>
    <Footer v-if="!isManager && !isSurveyCakePage"></Footer>
    <copyright v-if="!isSurveyCakePage"></copyright>
  </div>
</template>

<script>
import HeaderNav from "@/components/global/HeaderNav";
import Copyright from "@/components/global/Copyright";
import Footer from "@/components/global/Footer";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    isManager() {
      return (
        this.userInfo.role == "admin" ||
        this.userInfo.role == "manager" ||
        this.userInfo.role == "editor" ||
        this.userInfo.role == "judge"
      );
    },
    isSurveyCakePage() {
      return this.$route.name === "SurveyCake";
    },
  },
  methods: {
    ...mapMutations("user", ["cleanUserInfo"]),
    ...mapActions("user", ["setAPIToken", "fetchUserInfo"]),
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    userLogout() {
      this.$router.push({ name: "Login" });
    },
    managerLogout() {
      this.$router.push({ name: "Login", query: { manager: true } });
    },
    async handleToken() {
      let token = localStorage.getItem("token");
      if (token) {
        await this.setAPIToken(token);
        try {
          await this.fetchUserInfo();
        } catch (e) {
          this.$message.warning("請重新登入");
        }
      }
    },
  },
  created() {
    this.$bus.$on("scrollTop", () => {
      this.scrollTop();
    });
    this.$bus.$on("userLogout", () => {
      this.userLogout();
    });
    this.$bus.$on("managerLogout", () => {
      this.managerLogout();
    });
    this.$bus.$on("userTokenError", () => {
      this.$message.warning("請重新登入");
      this.userLogout();
    });
    this.$bus.$on("managerTokenNotFound", () => {
      this.$message.warning("請重新登入");
      this.managerLogout();
    });
    this.handleToken();
  },
  mounted() {},
  components: {
    Copyright,
    Footer,
    HeaderNav,
  },
};
</script>

<style lang="scss">
@import "src/scss/layout.scss";
@import "src/scss/color.scss";
@import "src/scss/element.scss";
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);

#app {
  min-width: 100%;
  min-height: 100%;
}

.layout-row {
  @extend %layout-row;
}

.layout-wrap {
  @extend %layout-wrap;
}

.layout-column {
  @extend %layout-column;
}

.layout-hv-center {
  @extend %layout-hv-center;
}

.layout-align-center {
  @extend %layout-align-center;
}

.layout-justify-center {
  @extend %layout-justify-center;
}

.pointer {
  @extend %pointer;
}

.normal-button {
  @extend %normal-button;
}
.normal-button:hover {
  @extend %normal-button:hover;
}

.normal-button-disable {
  @extend %normal-button-disable;
}

.button-tp {
  @extend %button-tp;
}

.normal-button:hover {
  @extend %button-tp:hover;
}
</style>

<style lang="scss" scoped>
.body {
  flex: 1;
}
</style>
